<template>
  <v-container fluid ma-0 pa-0 >
    <v-navigation-drawer app v-model="drawer">
    

      
    <template v-slot:prepend>
        <div class="pa-2">
          <div class="title font-weight-bold primary--text">DreamROI v2.0</div>
        </div>
      </template>
      
      <v-list-item v-if="$vuetify.breakpoint.mobile">
        <v-list-item-content>
          <v-list-item-title class="title title font-weight-bold">
            {{ item ? item.name : $t('common.loading') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $t('companies.companyAdministration')}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <action-button :tooltip="$t('companies.backToList')" icon="$up" to="/companies" />  
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        nav
        dense
      >
        <v-list-item
          v-for="i in visibleMenu"
          :key="i.title"
          :id="i.id"
          link
          :to="i.to"
          active-class="primary--text"
          exact
          
        >
          <v-list-item-icon>
            <v-icon>{{ i.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ i.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    <v-list>

    </v-list>
    </v-navigation-drawer>
    <!--
    <wizard-stepper v-if="wizard" :steps="currentWizard" :step="displayStep" class="mb-5" />
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
    <v-banner dark single-line elevation="10" color="error" icon="$warn" v-if="!isActive">
            {{ $t('companies.inactive') }}
            <template v-slot:actions>
            <v-btn
                text
                href="mailto:support@dreamroi.com"
                target="_blank"
            >
            {{ $t('common.contactSupport')}}
            </v-btn>
            </template>
    </v-banner>
    
    <v-banner single-line elevation="10" color="warning" icon="$warn" v-if="isTrial">
            {{ $t('companies.trial') }}
            <template v-slot:actions>
            <v-btn
                text
                :to="{name: 'plan'}"
            >
            {{ $t('companies.selectPlan')}}
            </v-btn>
            </template>
    </v-banner>
    
    <router-view />
    </v-container>
</template>

<script>

  import { mapState, mapGetters } from "vuex";
  import ParseRoute from "@/mixins/parse-route";
  import Drawer from "@/mixins/drawer";
  //import WizardStepper from '@/components/WizardStepper';
  import Wizards from '@/mixins/wizards';

  export default {
    name: 'Company',
    //components: { WizardStepper },
    mixins: [ParseRoute, Drawer, Wizards],
    data() {
      return {
      }
    },
    computed: {
       isOwner() {
            return this.$store.getters['auth/isOwner']({ item: this.item })
       },
       menu() { return [
          { id: 'menuDomains', title: this.$t('domains.title'), icon: '$domain', to: this.buildUrl(''), editors: true },
          { id: 'menuNewDomain', title: this.$t('domains.new'), icon: '$add', to: this.buildUrl('add-domain') },
          { id: 'menuPlans', title: this.$t('plan.title'), icon: '$plan', to: this.buildUrl('plan'), stripe: true },
          { id: 'menuBilling', title: this.$t('billing.title'), icon: '$billing', to: this.buildUrl('billing'), stripe: true },
          { id: 'menuBusiness', title: this.$t('businessInfo.title'), icon: '$domain', to: this.buildUrl('business')},
          { id: 'menuAccess', title: this.$t('accessRights.title'), icon: '$access', to: this.buildUrl('access')}
        ] },
        visibleMenu() {
          return this.menu.filter(i => this.isOwner || i.editors || this.$store.getters['auth/isHelpdesk']).filter(i => !i.stripe || (!this.item?.hasManualInvoicing && this.isOwner));
        },
      ...mapState('companies', ['item']),
      ...mapGetters('companies', ['isActive', 'isTrial'])
    },
    watch: {
    },
    methods: {
    },
    mounted() {
      this.wizardLifecycleControl();
    }
  }
</script>
